export const iconFontAwesomeEmojiFaceMeh = (
	<i className="fa-solid fa-face-meh"></i>
);
